var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralExtractT = function SvgDAhuGeneralExtractT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 581,
    cy: 168.1,
    rx: 11,
    ry: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581,158.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S575.5,158.1,581,158.1 M581,157.1c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S587.1,157.1,581,157.1L581,157.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M583.3,165.5h-1.8v4.9h-1v-4.9h-1.8v-0.8h4.5V165.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 179,
    width: 2,
    height: 22
  })))));
};
export default SvgDAhuGeneralExtractT;